import { Pipe, PipeTransform } from '@angular/core';
import { AgentChangesService, AgentSearchService } from 'ag-common-svc/public-api';
import { from, Observable, of, shareReplay } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { ImageCropperPayload } from '../../../../../../../../ag-common-lib/projects/ag-common-lib/src/lib/models/utils/image-cropper.model';

@Pipe({ name: 'agentWasabiPath' })
export class AgentWasabiPathPipe implements PipeTransform {
  constructor(
    private readonly agentSearchService: AgentSearchService,
    private readonly agentChangesService: AgentChangesService,
  ) {}

  transform(agentDbId: string): Observable<{ wasabiPath: string; imageCropperPayload?: ImageCropperPayload } | null> {
    if (!agentDbId) {
      return of(null);
    }
    return this.agentChangesService.agentChanged$(agentDbId).pipe(
      startWith(undefined),
      switchMap(() => from(this.agentSearchService.getById(agentDbId))),
      map(data => {
        if (data) {
          const headshot = {
            wasabiPath: data?.head_shot?.wasabiPath,
            imageCropperPayload: data?.head_shot?.imageCropperPayload,
          };
          return headshot || null;
        }
        return null;
      }),
      shareReplay(1),
    );
  }
}
